module.exports = __webpack_public_path__ + "img/plus.c4992546.svg";